import React from "react";
import { Mail, MessageCircle } from "lucide-react";
import portfolio from "@/data/portfolio";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t hairline bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="font-serif-display text-3xl md:text-4xl text-black tracking-tight">
              Pablo Marquez
            </div>
            <p className="mt-3 text-sm text-gray-500 max-w-sm">
              Executive · Founder · Sports innovator. Building at the intersection of equestrian sport, premium media and venture-backed technology.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs font-semibold uppercase tracking-[0.22em] text-gray-500">
              Reach
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href={`mailto:${portfolio.contact.email}`} className="text-gray-700 hover:text-black">{portfolio.contact.email}</a></li>
              <li><a href={portfolio.contact.whatsappUrl} target="_blank" rel="noreferrer" className="text-gray-700 hover:text-black">{portfolio.contact.whatsapp}</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs font-semibold uppercase tracking-[0.22em] text-gray-500">
              Direct
            </div>
            <div className="mt-4 flex items-center gap-4 text-gray-500">
              <a href={`mailto:${portfolio.contact.email}`} aria-label="Email" className="hover:text-black"><Mail className="w-4 h-4" /></a>
              <a href={portfolio.contact.whatsappUrl} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="hover:text-black"><MessageCircle className="w-4 h-4" /></a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t hairline flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="text-xs text-gray-500">
            © {new Date().getFullYear()} Pablo Marquez. Executive Portfolio.
          </div>
          <a
            href={`${BACKEND_URL}/api/cv/download`}
            data-testid="footer-download-cv"
            className="text-xs uppercase tracking-[0.22em] text-gray-600 hover:text-black"
          >
            Download executive PDF →
          </a>
        </div>
      </div>
    </footer>
  );
}
